<template lang="html">
  <div class="user-info">
    <div
      class="user-profile"
      :class="{ active: user.uid === userId }"
      v-if="user"
      @click="userDetail(user)"
    >
      <img
        v-lazy="
          $$viewImageInCenter(
            user.workImage || user.headImage || default_pic,
            340,
            360
          )
        "
        alt=""
        class="bigpic"
      />
      <div class="profile-summary bigcard">
        <div class="address">
          <p>{{ user.place || params.cityname || '江苏省南京市' }}</p>
          <p><span>|</span>从业{{ user.workAge }}年</p>
        </div>
        <p class="serve-count">历史服务：{{ user.servicedTimes }}单</p>
        <p class="service">擅长：{{ serviceDisplay }}</p>
        <div class="name">
          <div class="avatar">
            <img :src="user.headImage | avatar(50, 50)" alt="" />
            <p>{{ user.workerName }}</p>
          </div>
          <p class="focus-num" v-if="user.goodCommentNum > 0">
            <i class="iconfont icon-zan"></i>{{ user.goodCommentNum }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  props: {
    // 是否显示箭头
    showArrow: {
      type: Boolean,
      default: true
    },
    // 是否显示地址
    showAddress: {
      type: Boolean,
      default: true
    },
    // 是否可服务
    canServe: {
      type: Boolean,
      default: true
    },
    // 用户信息
    user: {
      type: Object,
      default: () => {}
    },
    // 已选中用户的id
    userId: {
      type: [Number, String],
      default: -1
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      default_pic: require('../../assets/images/default_headerimg.png')
    }
  },
  computed: {
    ...mapState(['serviceTypeList']),
    serviceDisplay() {
      const attr = this.user.workCategorys
      if (attr) {
        const attr_names = attr.map(ele => ele.categoryName)
        return attr_names.join('、') || '暂未开通服务'
      }
      return '暂未开通服务'
    }
  },
  methods: {
    userDetail(user) {
      if (this.canServe) {
        this.$emit('userDetail', user)
      }
    },
    score(score) {
      if (score === '' || score === '0') {
        return 0
      } else {
        return Math.ceil(score / 2)
      }
    },
    gotoUserDetail(user) {
      if (!user.uid) return
      this.$$tracker('110101', '20000', 21043, user.workerCode)
      this.$router.push({
        name: 'user',
        params: {
          uid: user.uid
        },
        query: {}
      })
      // this.$$loading(true)
      // // if (user.source !== 'pop') {
      //     location.href = `${this.$$hostname('shequ')}/bbs/user/${user.uid}`
      // } else {
      // location.href = `/v/user/${user.uid}`
      // }
    }
  },
  components: {
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.user-info {
  width: 50%;
  padding-left: rem(10px);
  padding-right: rem(10px);
  padding-top: rem(30px);
  display: inline-block;
  box-sizing: border-box;
}
.user-profile {
  box-shadow: rem(1px) rem(2px) rem(6px) rgba(0, 0, 0, 0.3);
  line-height: 0;

  .bigpic {
    width: rem(340px);
    height: rem(360px);
  }

  .profile-summary {
    color: #121212;
    font-size: rem(28px);
    padding: rem(20px);
    line-height: 1.3;

    .address {
      display: flex;
      // line-height: 1.2;
      padding-bottom: rem(5px);

      p:first-child {
        max-width: rem(180px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: rem(6px);
      }
      p:last-child {
        max-width: rem(120px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          padding-right: rem(6px);
        }
      }
    }
    .service {
      max-width: rem(300px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .name {
      padding-top: rem(20px);
      display: flex;
      align-items: center;

      .avatar {
        flex: 1;
        margin-right: rem(20px);
        display: flex;
        align-items: center;

        p {
          padding-left: rem(10px);
          font-size: rem(26px);
          color: #666;
        }

        img {
          width: rem(50px);
          height: rem(50px);
          border-radius: 50%;
        }
      }
      .focus-num {
        font-size: rem(24px);
        color: #999;

        .iconfont {
          padding-right: rem(10px);
          font-size: rem(26px);
        }
      }
    }
  }
}
</style>
